import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {
  AccountBox,
  AccountTree,
  Add,
  AddComment,
  Article,
  AssignmentTurnedIn,
  AssuredWorkload,
  BusinessCenterRounded,
  CastForEducation,
  Chat,
  ChevronLeft,
  ChevronRight,
  Contacts,
  Delete,
  Drafts,
  EventAvailable,
  ExpandLess,
  ExpandMore,
  Extension,
  LocalAtm,
  LocalMall,
  LocalOffer,
  Logout,
  Mail,
  MailOutline,
  MiscellaneousServices,
  Newspaper,
  Notifications,
  Outbox,
  People,
  Person,
  QuestionAnswer,
  Receipt,
  Send,
  SensorOccupied,
  Settings,
  SettingsAccessibilityRounded,
  ShoppingCartCheckout,
  SpeedRounded,
  TrendingUp,
  VpnKey,
} from "@mui/icons-material";
import Conts from "../../Tools/Contacts";
import Create from "../../Tools/Create";
import Setter from "../../Tools/Settings";
import Inbx from "../../Tools/Inbox";
import Snt from "../../Tools/Sent";
import Drft from "../../Tools/Draft";
import Outbx from "../../Tools/Outbox";
import Bin from "../../Tools/Bin";
import EmployeeReg from "./EmployeeReg";
import Attendance from "./Attendance";
import Payroll from "./Payroll";
import kalsoft_logo from "../../images/logo/kalsoft_logo.png";
import Peopl from "./People";
import { CalendarIcon } from "@mui/x-date-pickers/icons";
import Cht from "./Chat";
import App from "../../Apps/MyApp";
import Userprofile from "./Userprofile";
import Cards from "./Cards";
import { Avatar, Badge, Button, Menu, MenuItem } from "@mui/material";
import Landing from "../../Bank/Landing";
import MyApp from "../../Apps/MyApp";
import { DataContext } from "../InitHrm";
import {useNavigate} from 'react-router-dom'
import { grey } from "@mui/material/colors";
import Company from "./Company";
import Notify from '../../Auth/Notification'

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: 0,
  [theme.breakpoints.up("sm")]: {
    width: 0,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

export default function MiniDrawer() {
  const navigate = useNavigate()
  const theme = useTheme();
  const [appBarTitle, setAppBarTitle] = React.useState("App");

  //user account icon
  const [anchorEl, setAnchoeEl] = React.useState(null);
  const accountMenu = Boolean(anchorEl);


  const [open, setOpen] = React.useState(false);
  const [openHrm, setOpenHrm] = React.useState(false);
  const [openButn, setOpenBtn] = React.useState(false);
  const [openMessenger, setOpenMessenger] = React.useState(false);
  const [mainBody, setMainBody] = React.useState(<MyApp />);
  const [openOverview, setOpenOverview] = React.useState(false);
  const [openManagement, setOpenManagement] = React.useState(false);
  const [openUser, setOpenUser] = React.useState(false);
  const [openMisc, setOpenMisc] = React.useState(false);
  const [openProduct, setOpenProduct] = React.useState(false);
  const [openOrder, setOpenOrder] = React.useState(false);
  const [openInvoice, setOpenInvoice] = React.useState(false);
  const [openBlog, setOpenBlog] = React.useState(false);
  const [openJobs, setOpenJobs] = React.useState(false);
  const [numOfSettings, setNumofSettings] = React.useState(1);

  const [frametitle, setFrametitle] = React.useState(null)

  const userData = React.useContext(DataContext);
  const [context, setContext] = React.useState(userData)
  

  //logout 
  React.useEffect(()=>{
    if(context === null){
      navigate('/',{replace:true})
    }
  },[context])
  const handleExpandHrm = () => {
    setOpenBtn(!openButn);
    setAppBarTitle("HRM");
  };

  const handleMessenger = () => {
    setOpenMessenger(!openMessenger);
    setAppBarTitle("Messenger");
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleUserAccount=()=>{

  }
  const handleLogout=()=>{
    context.resetUser()
    navigate('/')
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={[
              {
                marginRight: 5,
              },
              open && { display: "none" },
            ]}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            {appBarTitle}
            </Typography>
            {context ? 
            <Box display='flex' ml={"auto"}>
            <Box display={context.profile.user.is_superuser ? 'flex':'none'} ml={"auto"}>
              <Button variant = {'outlined'} color={grey[50]} sx={{mr:2, borderRadius:4}} onClick={()=>{setMainBody(<Company/>); setFrametitle('Company Profile')}}>
                My Company
              </Button>
              </Box>
              <Typography variant="h6" noWrap component="div" alignSelf={'right'}>
            Welcome {context.profile.user.username}
          </Typography>
              </Box>
               : null}
            
          
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <Box display={"flex"} alignItems={"center"}>
            <Avatar src={kalsoft_logo} height={50} width={50} alt="logo" />
            <Typography variant="h6" mr={"auto"}>
              KALSoft
            </Typography>
            <IconButton onClick={handleDrawerClose} sx={{ ml: "auto" }}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </Box>
        </DrawerHeader>
        <Divider />
        <List>
          <ListItemButton
            onClick={() => {
              setOpenOverview(!openOverview);
              setAppBarTitle("Overview");
            }}
          >
            <ListItemIcon>
              <SpeedRounded />
            </ListItemIcon>
            <ListItemText primary="Overview" />
            {openOverview ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openOverview} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setMainBody(<App stageChanger={setMainBody} />);
                }}
              >
                <ListItemIcon>
                  <Extension />
                </ListItemIcon>
                <ListItemText primary="App" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setMainBody(<App stageChanger={setMainBody} />);
                }}
              >
                <ListItemIcon>
                  <LocalMall />
                </ListItemIcon>
                <ListItemText primary="Ecommerce" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setMainBody(<Landing stageChanger={setMainBody} />);
                }}
              >
                <ListItemIcon>
                  <AssuredWorkload />
                </ListItemIcon>
                <ListItemText primary="Banking" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setMainBody(null);
                }}
              >
                <ListItemIcon>
                  <LocalOffer />
                </ListItemIcon>
                <ListItemText primary="Bookings" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setMainBody(<EmployeeReg stageChanger={setMainBody} />);
                }}
              >
                <ListItemIcon>
                  <Article />
                </ListItemIcon>
                <ListItemText primary="Files" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setMainBody(<EmployeeReg stageChanger={setMainBody} />);
                }}
              >
                <ListItemIcon>
                  <CastForEducation />
                </ListItemIcon>
                <ListItemText primary="Courses" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setMainBody(<EmployeeReg stageChanger={setMainBody} />);
                }}
              >
                <ListItemIcon>
                  <TrendingUp />
                </ListItemIcon>
                <ListItemText primary="Analytics" />
              </ListItemButton>
            </List>
          </Collapse>
          {context?
          context.profile.user.is_superuser?
          <ListItemButton
            onClick={() => {
              setOpenManagement(!openManagement);
              setAppBarTitle("Management");
            }}
          >
            <ListItemIcon>
              <AccountTree />
            </ListItemIcon>
            <ListItemText primary="Management" />
            {openManagement ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          :null:null}
          <Collapse in={openManagement} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setOpenHrm(!openHrm);
                }}
              >
                <ListItemIcon>
                  <SensorOccupied />
                </ListItemIcon>
                <ListItemText primary="HRM" />
                {openHrm ? <ChevronLeft /> : <ChevronRight />}
              </ListItemButton>
              <Collapse in={openHrm} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      setOpenUser(!openUser);
                    }}
                  >
                    <ListItemIcon></ListItemIcon>
                    <ListItemText
                      primary={<Typography variant="body2">User</Typography>}
                    />
                    {openUser ? <ChevronLeft /> : <ChevronRight />}
                  </ListItemButton>
                  <Collapse in={openUser} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => {
                          setMainBody(<Userprofile />); handleDrawerClose()
                        }}
                      >
                        <ListItemText primary="Profile" />
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => {
                          setMainBody(<Peopl stageChanger={setMainBody} />);
                        }}
                      >
                        <ListItemText primary="List" />
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => {
                          setMainBody(
                            <EmployeeReg stageChanger={setMainBody} />
                          ); handleDrawerClose()
                        }}
                      >
                        <ListItemText primary="Create" />
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => {
                          setMainBody(<Cards />);handleDrawerClose()
                        }}
                      >
                        <ListItemText primary="Card" />
                      </ListItemButton>
                      <ListItemButton sx={{ pl: 4 }} onClick={() => {}}>
                        <ListItemText primary="Edit" />
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => {
                          //open this tab in the field
                        }}
                      >
                        <ListItemText primary="My Account" />
                      </ListItemButton>
                    </List>
                  </Collapse>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      setMainBody(<Attendance stageChanger={setMainBody} />);handleDrawerClose()
                    }}
                  >
                    <ListItemIcon></ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="body2">Attendance</Typography>
                      }
                    />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      setMainBody(<Payroll stageChanger={setMainBody} />);handleDrawerClose()
                    }}
                  >
                    <ListItemIcon></ListItemIcon>
                    <ListItemText
                      primary={<Typography variant="body2">Payroll</Typography>}
                    />
                  </ListItemButton>
                </List>
              </Collapse>

              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setOpenProduct(!openProduct);
                }}
              >
                <ListItemIcon>
                  <AssignmentTurnedIn />
                </ListItemIcon>
                <ListItemText primary="Products" />
                {openProduct ? <ChevronLeft /> : <ChevronRight />}
              </ListItemButton>
              <Collapse in={openProduct} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="List" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Details" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Create" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Edit" />
                  </ListItemButton>
                </List>
              </Collapse>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setOpenOrder(!openOrder);
                }}
              >
                <ListItemIcon>
                  <ShoppingCartCheckout />
                </ListItemIcon>
                <ListItemText primary="Orders" />
                {openOrder ? <ChevronLeft /> : <ChevronRight />}
              </ListItemButton>
              <Collapse in={openOrder} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="List" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Details" />
                  </ListItemButton>
                </List>
              </Collapse>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setOpenInvoice(!openInvoice);
                }}
              >
                <ListItemIcon>
                  <Receipt />
                </ListItemIcon>
                <ListItemText primary="Invoice" />
                {openInvoice ? <ChevronLeft /> : <ChevronRight />}
              </ListItemButton>
              <Collapse in={openInvoice} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="List" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Details" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Create" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Edit" />
                  </ListItemButton>
                </List>
              </Collapse>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setOpenBlog(!openBlog);
                }}
              >
                <ListItemIcon>
                  <Newspaper />
                </ListItemIcon>
                <ListItemText primary="Blog" />
                {openBlog ? <ChevronLeft /> : <ChevronRight />}
              </ListItemButton>
              <Collapse in={openBlog} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="List" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Details" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Create" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Edit" />
                  </ListItemButton>
                </List>
              </Collapse>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setOpenJobs(!openJobs);
                }}
              >
                <ListItemIcon>
                  <BusinessCenterRounded />
                </ListItemIcon>
                <ListItemText primary="Jobs" />
                {openJobs ? <ChevronLeft /> : <ChevronRight />}
              </ListItemButton>
              <Collapse in={openJobs} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="List" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Details" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Create" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //open this tab in the field
                    }}
                  >
                    <ListItemText primary="Edit" />
                  </ListItemButton>
                </List>
              </Collapse>
              <ListItemButton sx={{ pl: 4 }} onClick={() => {}}>
                <ListItemIcon>
                  <Mail />
                </ListItemIcon>
                <ListItemText primary="Mail" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                onClick={() => {
                  setMainBody(<Cht />);
                }}
              >
                <ListItemIcon>
                  <QuestionAnswer />
                </ListItemIcon>
                <ListItemText primary="Chat" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} onClick={() => {}}>
                <ListItemIcon>
                  <CalendarIcon />
                </ListItemIcon>
                <ListItemText primary="Calendar" />
              </ListItemButton>
            </List>
          </Collapse>
          
          <ListItemButton
            onClick={() => {
              setOpenMisc(!openMisc);
              setAppBarTitle("Miscellaneous");
            }}
          >
            <ListItemIcon>
              <MiscellaneousServices />
            </ListItemIcon>
            <ListItemText primary="Miscellaneous" />
            {openMisc ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openMisc} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} onClick={() => {}}>
                <ListItemIcon>
                  <VpnKey />
                </ListItemIcon>
                <ListItemText primary="Permissions" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} onClick={() => {}}>
                <ListItemIcon>
                  <Settings />
                </ListItemIcon>
                <ListItemText primary="Settings" />
              </ListItemButton>
            </List>
          </Collapse>
          <List>
            <ListItemButton onClick={handleMessenger}>
              <ListItemIcon>
                <Chat />
              </ListItemIcon>
              <ListItemText primary="Messenger" />
              {openMessenger ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={openMessenger} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => setMainBody(<Create />)}
                >
                  <ListItemIcon>
                    <AddComment />
                  </ListItemIcon>
                  <ListItemText primary="New Message" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => setMainBody(<Inbx setMain={setMainBody} />)}
                >
                  <ListItemIcon>
                    <MailOutline />
                  </ListItemIcon>
                  <ListItemText primary="Inbox" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => setMainBody(<Snt setMain={setMainBody} />)}
                >
                  <ListItemIcon>
                    <Send />
                  </ListItemIcon>
                  <ListItemText primary="Sent" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => setMainBody(<Drft setMain={setMainBody} />)}
                >
                  <ListItemIcon>
                    <Drafts />
                  </ListItemIcon>
                  <ListItemText primary="Drafts" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => setMainBody(<Outbx setMain={setMainBody} />)}
                >
                  <ListItemIcon>
                    <Outbox />
                  </ListItemIcon>
                  <ListItemText primary="Outbox" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => setMainBody(<Bin />)}
                >
                  <ListItemIcon>
                    <Delete />
                  </ListItemIcon>
                  <ListItemText primary="Bin" />
                </ListItemButton>
                <Divider variant="middle" />
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => setMainBody(<Conts />)}
                >
                  <ListItemIcon>
                    <Contacts />
                  </ListItemIcon>
                  <ListItemText primary="Contacts" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() =>
                    setMainBody(<Setter setMainBody={setMainBody} />)
                  }
                >
                  <ListItemIcon>
                    <Settings />
                  </ListItemIcon>
                  <ListItemText primary="Settings" />
                </ListItemButton>
              </List>
            </Collapse>
          </List>

          <Divider />
          <List>{/* Extra Menu options */}</List>
        </List>
      </Drawer>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3 }}
        style={{ maxHeight: "100%", overflow: "auto" }}
      >
        <DrawerHeader />
        <Box display={"flex"} justifyContent={"end"} columnGap={2} mb={1}>
          <Typography variant="h6" sx={{fontWeight:'bold'}} mr={'auto'}>{frametitle}</Typography>
        <Badge badgeContent = {numOfSettings} max={5} color="error">
          <IconButton onClick={()=>{setMainBody(<Company/>); setNumofSettings(0) }}>
            <Settings />
          </IconButton>
          </Badge>
          <IconButton onClick={()=>setMainBody(<Notify />)}>
            <Notifications />
          </IconButton>
          <IconButton onClick={(e)=>setAnchoeEl(e.currentTarget)}>
            <Person />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            id="user-account-menu"
            open={accountMenu}
            onClose={()=>setAnchoeEl(null)}
            onClick={()=>setAnchoeEl(null)}
            slotProps={{
              paper: {
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem onClick={()=>{handleUserAccount(); 
                          setMainBody(<Userprofile />)}
                        }>
              <Avatar /> Profile
            </MenuItem>
            <Divider />
            <MenuItem onClick={()=>setContext(null)}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Box>
        
        {mainBody}
      </Box>
    </Box>
  );
}
